// oRPC contract — the single, type-safe description of the whole API surface.
// The server implements this; the client is generated from it. Both import the same object.

import { oc } from '@orpc/contract';
import { z } from 'zod';
import {
  addActivityInput,
  appIdInput,
  appSchema,
  appWithPlansSchema,
  bulkCreateResearchInput,
  campaignSchema,
  costsSummarySchema,
  createAppInput,
  createCampaignInput,
  createLeadInput,
  createResearchInput,
  dashboardSummarySchema,
  idInput,
  leadDetailSchema,
  leadSchema,
  leadWithEconSchema,
  logCallInput,
  okSchema,
  promoteResearchInput,
  researchSchema,
  settingsSchema,
  updateCampaignSpendInput,
  updateLeadInput,
  updateResearchNoteInput,
  updateSettingsInput,
} from './schemas';

export const contract = {
  apps: {
    list: oc.output(z.array(appWithPlansSchema)),
    create: oc.input(createAppInput).output(appSchema),
    remove: oc.input(idInput).output(okSchema),
  },

  settings: {
    get: oc.output(settingsSchema),
    update: oc.input(updateSettingsInput).output(settingsSchema),
  },

  campaigns: {
    list: oc.output(z.array(campaignSchema)),
    create: oc.input(createCampaignInput).output(campaignSchema),
    updateSpend: oc.input(updateCampaignSpendInput).output(campaignSchema),
  },

  research: {
    list: oc.input(appIdInput).output(z.array(researchSchema)),
    create: oc.input(createResearchInput).output(researchSchema),
    bulkCreate: oc.input(bulkCreateResearchInput).output(z.array(researchSchema)),
    updateNote: oc.input(updateResearchNoteInput).output(researchSchema),
    remove: oc.input(idInput).output(okSchema),
    promote: oc.input(promoteResearchInput).output(leadSchema),
  },

  leads: {
    list: oc.input(appIdInput).output(z.array(leadWithEconSchema)),
    get: oc.input(idInput).output(leadDetailSchema),
    create: oc.input(createLeadInput).output(leadSchema),
    update: oc.input(updateLeadInput).output(leadSchema),
    addActivity: oc.input(addActivityInput).output(leadDetailSchema),
    logCall: oc.input(logCallInput).output(leadDetailSchema),
  },

  dashboard: {
    summary: oc.input(appIdInput).output(dashboardSummarySchema),
  },

  costs: {
    summary: oc.input(appIdInput).output(costsSummarySchema),
  },
};

export type Contract = typeof contract;
